import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import Store from './store';
import { MECHA_INFO } from './config';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
import cx from 'classnames';
import aos from '@src/utils/aos';
const styles = require('./index.less');

const MechaUnit = ({ store }) => {
  store.use();
  const mecha_info = () => {
    const mechaComp = MECHA_INFO[store.mechaId]?.component;
    if (mechaComp) {
      return React.createElement(mechaComp, { store: store.mechaStore });
    }
    return <Page />;
  };

  const mechaUnitTabSwiper = () => {
    if (store?.mechaUnitTab.length) {
      return (
        <BaseSwiper store={store.mechaUnitTabSwiper}>
          {store?.mechaUnitTab?.map((item, index) => {
            return (
              <div className={cx('tabItem')} key={index}>
                <div className={cx(store.mechaId === item.mechaId && 'active')}>
                  <img className={'mechaImg'} src={item.mecha_tab_icon} mechaid={item.mechaId} alt={''} />
                  <img className={'mechaImgAct'} src={item.mecha_tab_icon_act} mechaid={item.mechaId} alt={''} />
                </div>
              </div>
            );
          })}
        </BaseSwiper>
      );
    }
  };

  return (
    <Page>
      {mecha_info()}

      <div className={styles.tabSwiper} {...aos.FADE_UP()}>
        <Link className={styles.prevBtn} onClick={store.mechaUnitTabSwiper.goPrev} />
        <Link className={styles.nextBtn} onClick={store.mechaUnitTabSwiper.goNext} />
        {mechaUnitTabSwiper()}
      </div>
    </Page>
  );
};

export default wrapStore(MechaUnit, Store);
